import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Card } from 'reactstrap';
import { doScrollSection } from "../../../actions/menuAction";
import FAQDetail from "../FAQ/FAQDetail";

//pengemasan

class Selling extends Component {
  constructor(props) {
    super(props);
    const { aboutProps } = this.props.location;
    const name = aboutProps && aboutProps.name || ""
    this.howToSellRef = createRef();
    this.commissionRef = createRef();
    this.sneakersSoldRef = createRef();
    this.packingSneakersRef = createRef();
    this.soldEarlierRef = createRef();
    this.mySellingRef = createRef();
    this.cancelSellingRef = createRef();
    this.moneyTransferedRef = createRef();

    this.state = {
      name
    };
  }

  render() {

    const { dataFAQ } = this.props

    const subDataFAQ = dataFAQ && dataFAQ[2]

    return (
      <div id="helps-container">
        <p className="title-card">{dataFAQ && dataFAQ[2].name}</p>
        <div ref={this.howToBuyRef}>
          <Card>
            {
              subDataFAQ && subDataFAQ.faq.map((item, index) => (
                <FAQDetail item={item} subFaq={subDataFAQ} index={index} dataSection={this.props.dataSection} />
              ))
            }
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  dataSection: state.dataMenu.section_name,
  dataFAQ: state.dataMenu.faqs.data
});

const mapDispatchToProps = dispatch => ({
  doScrollSection: name => dispatch(doScrollSection(name))
});

export default connect(mapStateToProps, mapDispatchToProps)(Selling)